import { render, staticRenderFns } from "./PosTransactions.vue?vue&type=template&id=0189add2&"
import script from "./PosTransactions.vue?vue&type=script&lang=js&"
export * from "./PosTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports